<template>
  <div>
    <div>
      <el-form size="small" label-width="100px" class="margin15-tb">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="模板名称">
            <el-input clearable v-model="templateName"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="模板内容">
            <el-input clearable v-model="templateContent" placeholder="前后加上#可搜索参数"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <div class="text left">
              <el-button type="primary" size="mini" @click="search">搜索</el-button>
              <el-button size="mini" @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <p>
        <el-button icon="el-icon-plus" type="primary" size="small" @click="addTemplate">创建模板</el-button>
        <el-button type="success" size="small" @click="exportExcel">导出Excel</el-button>
        <el-button size="small"  type="danger" @click="upload()">短信模板导入</el-button>
      </p>
    </div>
    <el-dialog title="导入短信模板" width="30%" center :visible.sync="importDialogVisible">
      <el-form label-width="100px" >
        <el-form-item label="文件上传" >
          <el-upload
            class="upload-demo"
            action=""
            ref="upload"
            :before-remove="beforeRemove"
            :limit="1"
            :auto-upload="false"
            :on-change="handleChange"
            :file-list="fileList">
            <el-button size="small" icon="el-icon-upload" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">请用模板进行修改上传</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="default" size="small" icon="el-icon-bottom"><a href="/static/template/msgTemplate.xlsx" download
            style="color: inherit; text-decoration: none;">模板下载</a></el-button>
        <el-button size="small" type="primary" @click="submitFile()">提交数据</el-button>
      </div>
    </el-dialog>
    <div class="padding15-tb">
      <el-table
        :data="list"
        v-loading="loading"
        size="small"
        border
        :span-method="objectSpanMethod"
        :header-cell-style="{textAlign: 'center'}"
        style="width: 100%">
        <el-table-column
          prop="name"
          align="center"
          label="模板名称"
          width="200px">
        </el-table-column>
        <el-table-column
          prop="templateType"
          align="center"
          width="200px"
          label="模板类型">
        </el-table-column>
        <el-table-column
          prop="contentShow"
          align="center"
          label="内容">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light" v-if="1 == $getInternationalVersionFlag()">
              <div v-if="languageSelect === '0'" v-html="scope.row.contentShowTrans ? scope.row.contentShowTrans : `---请补充中文翻译---<br>${scope.row.contentShow}`"></div>
              <div v-else v-html="scope.row.contentShow"></div>
              <div v-if="languageSelect === '0'" slot="content" v-html="scope.row.contentShow"></div>
              <div v-else slot="content" v-html="scope.row.contentShowTrans ? scope.row.contentShowTrans : '---请补充中文翻译---'"></div>
            </el-tooltip>
            <div v-html="scope.row.contentShow" v-else></div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="180px">
          <template slot-scope="scope">
            <el-button type="text" size="medium" icon="el-icon-plus" v-if="scope.row.parentId === null" @click="addChildTemplate(scope.row)"></el-button>
            <el-button type="text" size="medium" icon="el-icon-edit-outline" @click="editTemplate(scope.row)"></el-button>
            <el-button type="text" size="medium" icon="el-icon-delete" @click="deleteTemplate(scope.row.id)"></el-button>
            &nbsp;
            <el-switch
              v-if="scope.row.parentId !== null"
              v-model="scope.row.status"
              @change="openAndCloseTemplate(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
      <div class="text center margin15-tb">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageData.currentPage"
          :page-sizes="[50, 100, 200]"
          :page-size="pageData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageData.totalCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    initTemplateFiled: {
      type: Function,
      default() {
      }
    },
    addOrEditTemplate: {
      type: Function,
      default() {
      }
    },
    deleteTemplate: {
      type: Function,
      default() {
      }
    },
    openAndCloseTemplate: {
      type: Function,
      default() {
      }
    },
    changeTabe: {
      type: String
    },
    companySelected: {
    },
    groupSelected: {
    },
    companyAmount: {
    }
  },
  watch: {
    changeTabe(type) {
      if (type === '短信模板列表') {
        if (this.companyId !== '') {
          this.getData(1);
        }
      }
    },
    companySelected(companyId) {
      this.companyId = companyId;
    },
    groupSelected(groupId) {
      this.groupId = groupId;
      if (this.changeTabe === '短信模板列表') {
        this.getData(1);
      }
    },
    companyAmount(amount) {
      this.amount = amount;
    }
  },
  data() {
    return {
      importDialogVisible: false,
      loading: true,
      list: [],
      spanArr: [],
      pos: 0,
      companyId: '',
      groupId: '',
      pageData: {},
      type: 'msg',
      templateName: '',
      templateContent: '',
      templateOperType: {
        addMsg: 'addMsg',
        addVoice: 'addVoice',
        addIvoice: 'addIvoice',
        add: 'add',
        edit: 'edit',
        addChildTemplate: 'addChildTemplate'
      },
      fileList: [],
      currentPage: 1,
      catchLanguageSelect: this.$getLanguageSelect()
    };
  },
  mounted() {
    this.initTemplateFiled(this.templateOperType);
    this.langChangeHandler = (newLang) => {
      this.catchLanguageSelect = newLang;
    };
    this.$bus.$on('languageSelectChanged', this.langChangeHandler);
  },
  beforeDestroy() {
    this.$bus.$off('languageSelectChanged', this.langChangeHandler);
  },
  methods: {
    getSpanArr(data) {
      this.spanArr = [];
      for (let i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else if (data[i].name === data[i - 1].name) {
          // 判断当前元素与上一个元素是否相同
          this.spanArr[this.pos] += 1;
          this.spanArr.push(0);
        } else {
          this.spanArr.push(1);
          this.pos = i;
        }
      }
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const rows = this.spanArr[rowIndex];
        const cols = rows > 0 ? 1 : 0;
        return {
          rowspan: rows,
          colspan: cols
        };
      }
      return { rowspan: 1, colspan: 1 };
    },
    getData(page) {
      this.loading = true;
      this.$ajax({
        url: '/template/getTemplates',
        method: 'POST',
        data: this.getSearchParam(page)
      }).then((res) => {
        this.list = res.data.list;
        this.getSpanArr(this.list);
        this.pageData.pageSize = res.data.limit;
        this.pageData.totalCount = res.data.totalRecords;
        this.pageData.currentPage = res.data.currentPage;
        this.currentPage = res.data.currentPage;
        this.loading = false;
      });
    },
    getSearchParam(page) {
      const req = {
        'companyId': this.companyId,
        'groupId': this.groupId,
        'type': this.type,
        'templateName': this.templateName,
        'templateContent': this.templateContent,
        'page': page,
        'limit': this.pageData.pageSize || 50,
        'order': 0,
        'sort': 0
      };
      return req;
    },
    getDataByFirst(companyId, groupId, page) {
      console.warn(page);
      this.companyId = companyId;
      this.groupId = groupId;
      this.getData(this.pageData.currentPage);
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.getData(1);
    },
    // 页码
    handleCurrentChange(val) {
      this.pageData.currentPage = val;
      this.currentPage = val;
      this.getData(val);
    },
    search() {
      this.getData(this.currentPage);
    },

    upload() {
      this.importDialogVisible = true;
      this.fileList = [];
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },

    submitFile() {
      this.importDialogVisible = false;
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      if (this.fileList === [] || this.fileList === null || this.fileList.length === 0) {
        this.$message.error('excel文件不能为空!');
        loading.close();
      }
      const fileList = this.fileList;
      const FileExt = fileList[0].name.replace(/.+\./, '').toLowerCase();
      const xlsxFlag = ['xlsx'].includes(FileExt);
      const isLt5M = fileList[0].size / 1024 / 1024 < 5;
      if (!xlsxFlag) {
        this.$message.error('文件格式错误请重新上传!');
        this.fileList = [];
        loading.close();
        this.importDialogVisible = false;
      }
      if (!isLt5M) {
        this.$message.error('上传的文件大小不能超过 5MB!');
        this.fileList = [];
        loading.close();
        this.importDialogVisible = false;
      }
      const formData = new FormData();
      formData.append('file', this.fileList[0].raw);
      formData.append('groupId', this.groupId);
      formData.append('companyId', this.companyId);
      this.$ajax({
        url: '/strategy/excel/importMsg',
        method: 'POST',
        prompt: true,
        contentType: 'multipart/form-data',
        data: formData
      }).then(() => {
        loading.close();
        this.importDialogVisible = false;
      }).catch(() => {
        loading.close();
        this.importDialogVisible = false;
      });
    },
    exportExcel() {
      this.$download({
        url: '/strategy/excel/exportMessageTemplate',
        method: 'POST',
        data: this.getSearchParam(1),
        name: '短信模板列表.xlsx'
      });
    },
    reset() {
      this.resetSearchParam();
    },
    resetSearchParam() {
      this.templateName = '';
      this.templateContent = '';
    },
    addTemplate() {
      this.addOrEditTemplate(true, this.templateOperType.addMsg, this.companyId, this.groupId, null);
    },
    addChildTemplate(row) {
      this.addOrEditTemplate(true, this.templateOperType.addChildTemplate, this.companyId, this.groupId, row);
    },
    editTemplate(row) {
      this.addOrEditTemplate(true, this.templateOperType.edit, this.companyId, this.groupId, row);
    }
  },
  computed: {
    languageSelect() {
      return this.catchLanguageSelect;
    }
  }
};
</script>
<style>
    .upload-demo {
      display: inline-block;
    }
</style>



// WEBPACK FOOTER //
// src/page/main/collection/engine/msg_template_list.vue